import deepFreeze from 'deep-freeze'

export const GeneralColumns = deepFreeze({
  operationStatus: {
    name: 'operationStatus',
    displayName: '운영상태',
  },
  campaignType: {
    name: 'campaignType',
    displayName: '캠페인 유형',
  },
  bizChannel: {
    name: 'bizChannel',
    displayName: '비즈채널',
  },
  dailyBudget: {
    name: 'dailyBudget',
    displayName: '일예산',
  },
  impressionDate: {
    name: 'impressionDate',
    displayName: '집행일자',
  },
  maxBiddingAmount: {
    name: 'maxBiddingAmount',
    displayName: '기본 입찰가',
  },
  impressionWeeklySchedule: {
    name: 'impressionWeeklySchedule',
    displayName: '집행요일/시간',
  },
  contentMatchingmaxBiddingAmount: {
    name: 'contentMatchingmaxBiddingAmount',
    displayName: '콘텐츠 매체 입찰가',
  },
  mediaType: {
    name: 'mediaType',
    displayName: '매체유형',
  },
  userDevice: {
    name: 'userDevice',
    displayName: '디바이스',
  },
  keywordEx: {
    name: 'keywordEx',
    displayName: '키워드확장',
  },
  campaign: {
    name: 'campaign',
    displayName: '캠페인',
  },
  reviewStatus: {
    name: 'reviewStatus',
    displayName: '심사상태',
  },
  keywordBiddingAmount: {
    name: 'keywordBiddingAmount',
    displayName: '키워드 입찰가',
  },
  score: {
    name: 'score',
    displayName: '품질지수',
  },
  exposureStatus: {
    name: 'exposureStatus',
    displayName: '노출현황',
  },
  landingUrlSetting: {
    name: 'landingUrlSetting',
    displayName: '랜딩 설정여부',
  },
  landingUrl: {
    name: 'landingUrl',
    displayName: '랜딩 URL',
  },
  adGroup: {
    name: 'adGroup',
    displayName: '광고그룹',
  },
  segmentKeyword: {
    name: 'segmentKeyword',
    displayName: '분절 키워드',
  },
})
export const MetricColumns = deepFreeze({
  viewableImpression: {
    name: 'viewableImpression',
    displayName: '노출수',
    tooltip: '광고가 노출된 viewable 횟수를 의미합니다.',
  },
  click: {
    name: 'click',
    displayName: '클릭수',
    tooltip: '광고가 클릭된 횟수를 의미합니다.',
  },
  spending: {
    name: 'spending',
    displayName: '비용',
    tooltip: (
      <>
        지출된 광고비로서 부가세는 포함되지 않은 금액을 의미합니다.
        <br />
        게재 중인 광고는 추정값이 표시 될 수 있으며 그에 따라 소수점이 일부 노출
        될 수 있습니다.
      </>
    ),
  },
  ctr: {
    name: 'ctr',
    displayName: '클릭률',
    suffix: '%',
    tooltip: (
      <>
        클릭수를 노출수로 나눈 값을 의미합니다.
        <br />
        (클릭률(%)=클릭수/노출수*100)
      </>
    ),
  },
  // 추가지표
  renderedImpression: {
    name: 'renderedImpression',
    displayName: '전체 노출수',
    tooltip: '광고의 rendering(화면에 그려진) 횟수를 의미합니다.',
  },
  ppc: {
    name: 'ppc',
    displayName: '클릭당비용',
    tooltip: (
      <>
        비용을 클릭수로 나눈 값을 의미합니다.
        <br />
        (클릭당 비용=비용/클릭수)
      </>
    ),
  },
  rank: {
    name: 'rank',
    displayName: '평균노출순위',
    tooltip: '키워드 기준으로 광고가 노출된 평균순위를 의미합니다.',
  },
  costPerImp: {
    name: 'costPerImp',
    displayName: '노출당비용',
    tooltip: (
      <>
        1,000회 광고 노출당 비용을 의미합니다.
        <br />
        (노출당 비용=비용/노출수)
      </>
    ),
  },
  // 픽셀&SDK 전환 지표
  convCmptReg1d: {
    name: 'convCmptReg1d',
    displayName: '회원가입 (1일)',
    tooltip: '광고 클릭 후, 24시간 이내 발생한 회원가입수를 의미합니다.',
  },
  convCmptReg7d: {
    name: 'convCmptReg7d',
    displayName: '회원가입 (7일)',
    tooltip: '광고 클릭 후, 7일 이내에 발생한 회원가입수를 의미합니다.',
  },
  convViewCart1d: {
    name: 'convViewCart1d',
    displayName: '장바구니 보기 (1일)',
    tooltip: '광고 클릭 후, 24시간 이내 장바구니를 확인해본 횟수를 의미합니다.',
  },
  convViewCart7d: {
    name: 'convViewCart7d',
    displayName: '장바구니 보기 (7일)',
    tooltip: '광고 클릭 후, 7일 이내에 장바구니를 확인해본 횟수를 의미합니다.',
  },
  convPurchase1d: {
    name: 'convPurchase1d',
    displayName: '구매 (1일)',
    tooltip: '광고 클릭 후, 24시간 이내 발생한 구매건수를 의미합니다.',
  },
  convPurchase7d: {
    name: 'convPurchase7d',
    displayName: '구매 (7일)',
    tooltip: '광고 클릭 후, 7일 이내에 발생한 구매건수를 의미합니다.',
  },
  convPurchaseP1d: {
    name: 'convPurchaseP1d',
    displayName: '구매금액 (1일)',
    tooltip: '광고 클릭 후, 24시간 이내 발생한 구매비용을 의미합니다.',
  },
  convPurchaseP7d: {
    name: 'convPurchaseP7d',
    displayName: '구매금액 (7일)',
    tooltip: '광고 클릭 후, 7일 이내에 발생한 구매비용을 의미합니다.',
  },
  convParticipation1d: {
    name: 'convParticipation1d',
    displayName: '잠재고객 (1일)',
    tooltip: '광고 클릭 후, 24시간 이내 발생한 잠재고객수를 의미합니다.',
  },
  convParticipation7d: {
    name: 'convParticipation7d',
    displayName: '잠재고객 (7일)',
    tooltip: '광고 클릭 후, 7일 이내에 발생한 잠재고객수를 의미합니다.',
  },
  convSignup1d: {
    name: 'convSignup1d',
    displayName: '서비스 신청 (1일)',
    tooltip: '광고 클릭 후, 24시간 이내 발생한 서비스 신청수를 의미합니다.',
  },
  convSignup7d: {
    name: 'convSignup7d',
    displayName: '서비스 신청 (7일)',
    tooltip: '광고 클릭 후, 7일 이내에 발생한 서비스 신청수를 의미합니다.',
  },
  convAppInstall1d: {
    name: 'convAppInstall1d',
    displayName: '앱 설치 (1일)',
    tooltip: '광고 클릭 후, 24시간 이내 발생한 앱 설치수를 의미합니다.',
  },
  convAppInstall7d: {
    name: 'convAppInstall7d',
    displayName: '앱 설치 (7일)',
    tooltip: '광고 클릭 후, 7일 이내에 발생한 앱 설치수를 의미합니다.',
  },
  // 카카오 친구 지표
  convKfPfAdd7d: {
    name: 'convKfPfAdd7d',
    displayName: '친구 추가 수 (7일)',
    tooltip:
      '광고 클릭 후, 7일 이내에 카카오톡 채널을 추가한 친구수를 의미합니다.',
  },
  costPerConvKfPfAdd7d: {
    name: 'costPerConvKfPfAdd7d',
    displayName: '친구 추가 수당 비용 (7일)',
    tooltip: (
      <>
        비용을 친구 추가 수 (7일)로 나눈 값을 의미합니다.
        <br />
        (친구 추가 수당 비용 (7일) = 비용/ 친구 추가 수 (7일))
      </>
    ),
  },
  convKfPfAdd7dRate: {
    name: 'convKfPfAdd7dRate',
    displayName: '친구 추가율 (7일)',
    suffix: '%',
    tooltip: (
      <>
        친구 추가 수 (7일)을 클릭수로 나눈 값을 의미합니다.
        <br />
        (친구 추가율 (7일) = 친구 추가 수 (7일) / 클릭수 X 100)
      </>
    ),
  },
  convKfPfAdd1d: {
    name: 'convKfPfAdd1d',
    displayName: '친구 추가 수 (1일)',
    tooltip:
      '광고 클릭 후, 24시간 이내에 카카오톡 채널을 추가한 친구수를 의미합니다.',
  },
  costPerConvKfPfAdd1d: {
    name: 'costPerConvKfPfAdd1d',
    displayName: '친구 추가 수당 비용 (1일)',
    tooltip: (
      <>
        비용을 친구 추가 수 (1일)로 나눈 값을 의미합니다.
        <br />
        (친구 추가 수당 비용 (1일) = 비용/ 친구 추가 수 (1일))
      </>
    ),
  },
  convKfPfAdd1dRate: {
    name: 'convKfPfAdd1dRate',
    displayName: '친구 추가율 (1일)',
    suffix: '%',
    tooltip: (
      <>
        친구 추가 수 (1일)을 클릭수로 나눈 값을 의미합니다.
        <br />
        (친구 추가율 (1일) = 친구 추가 수 (1일) / 클릭수 X 100)
      </>
    ),
  },
})
export const MetricIds = Object.keys(MetricColumns)
export const EtcColumns = deepFreeze({
  campaignId: {
    name: 'campaignId',
    displayName: '캠페인 ID',
  },
  createdDate: {
    name: 'createdDate',
    displayName: '등록시간',
  },
  updatedDate: {
    name: 'updatedDate',
    displayName: '수정시간',
  },
  adGroupId: {
    name: 'adGroupId',
    displayName: '광고그룹 ID',
  },
  keywordId: {
    name: 'keywordId',
    displayName: '키워드 ID',
  },
  creativeLinkId: {
    name: 'creativeLinkId',
    displayName: '소재연결 ID',
  },
  creativeId: {
    name: 'creativeId',
    displayName: '소재 ID',
  },
})
export const Columns = {
  ...GeneralColumns,
  ...MetricColumns,
  ...EtcColumns,
}
export const ColumnIds = Object.keys(Columns)
export const ColumnSorts = {
  name: {
    name: 'name',
    title: '이름순',
    defaultOrder: 'asc',
  },
  text: {
    name: 'text',
    title: '이름순',
    defaultOrder: 'asc',
  },
  createdDate: {
    name: 'createdDate',
    title: '등록일순',
    defaultOrder: 'desc',
  },
  updatedDate: {
    name: 'updatedDate',
    title: '수정일순',
    defaultOrder: 'desc',
  },
  reviewStatus: {
    name: 'reviewStatus',
    title: '심사상태순',
    defaultOrder: 'asc',
  },
  status: {
    name: 'status',
    title: '상태순',
    defaultOrder: 'asc',
    reverse: true,
  },
  bizChannelId: {
    name: 'bizChannelId',
    title: '비즈채널',
    defaultOrder: 'asc',
  },
  landingUrl: {
    name: 'landingUrl',
    title: '랜딩 URL',
    defaultOrder: 'asc',
  },
  'biddingStrategy.maxBiddingAmount': {
    name: 'biddingStrategy.maxBiddingAmount',
    title: '입찰가',
    defaultOrder: 'asc',
  },
  viewableImpression: {
    name: 'viewableImpression',
    defaultOrder: 'desc',
  },
  click: {
    name: 'click',
    defaultOrder: 'desc',
  },
  spending: {
    name: 'spending',
    defaultOrder: 'desc',
  },
  ctr: {
    name: 'ctr',
    defaultOrder: 'desc',
  },
  renderedImpression: {
    name: 'renderedImpression',
    defaultOrder: 'desc',
  },
  ppc: {
    name: 'ppc',
    defaultOrder: 'desc',
  },
  rank: {
    name: 'rank',
    defaultOrder: 'desc',
  },
  convCmptReg1d: {
    name: 'convCmptReg1d',
    defaultOrder: 'desc',
  },
  convViewCart1d: {
    name: 'convViewCart1d',
    defaultOrder: 'desc',
  },
  convPurchase1d: {
    name: 'convPurchase1d',
    defaultOrder: 'desc',
  },
  convPurchaseP1d: {
    name: 'convPurchaseP1d',
    defaultOrder: 'desc',
  },
  convParticipation1d: {
    name: 'convParticipation1d',
    defaultOrder: 'desc',
  },
  convSignup1d: {
    name: 'convSignup1d',
    defaultOrder: 'desc',
  },
  convAppInstall1d: {
    name: 'convAppInstall1d',
    defaultOrder: 'desc',
  },
  convCmptReg7d: {
    name: 'convCmptReg7d',
    defaultOrder: 'desc',
  },
  convViewCart7d: {
    name: 'convViewCart7d',
    defaultOrder: 'desc',
  },
  convPurchase7d: {
    name: 'convPurchase7d',
    defaultOrder: 'desc',
  },
  convPurchaseP7d: {
    name: 'convPurchaseP7d',
    defaultOrder: 'desc',
  },
  convParticipation7d: {
    name: 'convParticipation7d',
    defaultOrder: 'desc',
  },
  convSignup7d: {
    name: 'convSignup7d',
    defaultOrder: 'desc',
  },
  convAppInstall7d: {
    name: 'convAppInstall7d',
    defaultOrder: 'desc',
  }, // 추가
  dailyBudget: {
    name: 'dailyBudget',
    title: '일예산',
    defaultOrder: 'desc',
  },
  campaignId: {
    name: 'campaignId',
    title: '캠페인 ID',
    defaultOrder: 'desc',
  },
  maxBiddingAmount: {
    name: 'maxBiddingAmount',
    title: '기본 입찰가',
    defaultOrder: 'desc',
  },
  impressionDate: {
    name: 'impressionDate',
    title: '집행일자',
    defaultOrder: 'asc',
  },
  impressionWeeklySchedule: {
    name: 'impressionWeeklySchedule',
    title: '집행요일/시간',
    defaultOrder: 'desc',
  },
  contentMatchingmaxBiddingAmount: {
    name: 'contentMatchingmaxBiddingAmount',
    title: '콘텐츠 매체 입찰가',
    defaultOrder: 'desc',
  },
  mediaType: {
    name: 'mediaType',
    title: '매체유형',
    defaultOrder: 'asc',
  },
  userDevice: {
    name: 'userDevice',
    title: '디바이스',
    defaultOrder: 'asc',
  },
  keywordEx: {
    name: 'keywordEx',
    title: '키워드확장',
    defaultOrder: 'asc',
  },
  adGroupId: {
    name: 'adGroupId',
    title: '광고그룹 ID',
    defaultOrder: 'desc',
  },
  keywordBiddingAmount: {
    name: 'keywordBiddingAmount',
    title: '키워드 입찰가',
    defaultOrder: 'desc',
  },
  landingUrlSetting: {
    name: 'landingUrlSetting',
    title: '랜딩 설정여부',
    defaultOrder: 'asc',
  },
  keywordId: {
    name: 'keywordId',
    title: '키워드 ID',
    defaultOrder: 'desc',
  },
  creativeLinkId: {
    name: 'creativeLinkId',
    title: '소재연결 ID',
    defaultOrder: 'desc',
  },
  creativeId: {
    name: 'creativeId',
    title: '소재 ID',
    defaultOrder: 'desc',
  },
  campaignType: {
    name: 'campaignType',
    title: '캠페인 유형',
    defaultOrder: 'desc',
  },
  segmentKeyword: {
    name: 'segmentKeyword',
    title: '분절 키워드',
    defaultOrder: 'asc',
  },
  costPerImp: {
    name: 'costPerImp',
    title: '노출당비용',
    defaultOrder: 'desc',
  },
  convKfPfAdd7d: {
    name: 'convKfPfAdd7d',
    title: '친구 추가 수 (7일)',
    defaultOrder: 'desc',
  },
  costPerConvKfPfAdd7d: {
    name: 'costPerConvKfPfAdd7d',
    title: '친구 추가 수당 비용 (7일)',
    defaultOrder: 'desc',
  },
  convKfPfAdd7dRate: {
    name: 'convKfPfAdd7dRate',
    title: '친구 추가율 (7일)',
    defaultOrder: 'desc',
  },
  convKfPfAdd1d: {
    name: 'convKfPfAdd1d',
    title: '친구 추가 수 (1일)',
    defaultOrder: 'desc',
  },
  costPerConvKfPfAdd1d: {
    name: 'costPerConvKfPfAdd1d',
    title: '친구 추가 수당 비용 (1일)',
    defaultOrder: 'desc',
  },
  convKfPfAdd1dRate: {
    name: 'convKfPfAdd1dRate',
    title: '친구 추가율 (1일)',
    defaultOrder: 'desc',
  },
}
